import { render, staticRenderFns } from "./customer-admin-header.vue?vue&type=template&id=f93a621a&scoped=true"
import script from "./customer-admin-header.vue?vue&type=script&lang=ts"
export * from "./customer-admin-header.vue?vue&type=script&lang=ts"
import style0 from "./customer-admin-header.vue?vue&type=style&index=0&id=f93a621a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93a621a",
  null
  
)

export default component.exports